import { render, staticRenderFns } from "./RealtorInsights.vue?vue&type=template&id=817f95d4&"
import script from "./RealtorInsights.vue?vue&type=script&lang=js&"
export * from "./RealtorInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports